"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductName = exports.shouldRefetch = exports.returnStateLoadingFalse = void 0;
const monet_1 = require("monet");
const locale_1 = require("../commercetools/locale");
const config_1 = require("../config");
const returnStateLoadingFalse = (_state, _action) => ({
    ..._state,
    loading: false,
    value: _action.payload
});
exports.returnStateLoadingFalse = returnStateLoadingFalse;
/**
 * Checks a timestamp and if it's older than the last hour on the clock returns true.
 * For example if it's 12:07 and the last update was 11:48 it will return true.
 */
const shouldRefetch = (lastFetched /** timestamp */) => {
    const lastHourFetched = new Date(lastFetched).getHours();
    const currentHour = new Date().getHours();
    return currentHour !== lastHourFetched;
};
exports.shouldRefetch = shouldRefetch;
/**
 * Returns the name for given product or line item for the current locale.
 */
const getProductName = (product) => (0, locale_1.localeFromString)(config_1.locale)
    .chain(_locale => monet_1.Maybe.fromNull(product?.name?.[_locale]))
    .getOrElse('');
exports.getProductName = getProductName;
//# sourceMappingURL=utils.js.map